<template>
  <div class="text-left px-6 pb-6">
    <div class="pt-11" @click="back">
      <back-arrow-icon :width="'w-4'" :height="'h-4'"></back-arrow-icon>
    </div>
    <div class="pt-7">
      <div class="text-2xl font-extrabold">Who are you?</div>
    </div>
    <div class="pt-3">
      <div class="text-base">I am the/a</div>
    </div>
    <div class="pt-9 flex" @click="selectSender">
      <div class="px-5 pt-3">
        <sender-icon></sender-icon>
      </div>
      <div>
        <div class="text-lg font-bold">Sender</div>
        <div class="pt-2 text-xs text-nw-ash">The dispatch rider will be picking up the package from me.</div>
      </div>
      <div class="pl-4 pt-8">
        <click-icon v-if="sender"></click-icon>
      </div>
    </div>
    <div class="border-b border-nw-ash border-dashed pt-6"></div>
    <div class="pt-7 flex" @click="selectReceiver">
      <div class="px-5 pt-3">
        <receiver-icon></receiver-icon>
      </div>
      <div>
        <div class="text-lg font-bold">Receiver</div>
        <div class="pt-2 text-xs text-nw-ash">The dispatch rider will be delivering the package to me.</div>
      </div>
      <div class="pl-4 pt-8">
        <click-icon v-if="receiver"></click-icon>
      </div>
    </div>
    <div class="border-b border-nw-ash border-dashed pt-6"></div>
    <div class="text-xs pt-20" @click="next">
      <input-button>CONTINUE</input-button>
    </div>
  </div>
</template>

<script>
import BackArrowIcon from '@/components/icons/BackArrowIcon.vue'
import ClickIcon from '@/components/icons/ClickIcon.vue'
import ReceiverIcon from '@/components/icons/ReceiverIcon.vue'
import SenderIcon from '@/components/icons/SenderIcon.vue'
import InputButton from '@/components/inputs/InputButton.vue'
import { mapState } from 'vuex'
import Swal from 'sweetalert2'
export default {
  props: {
    id: [String, Number]
  },
  components: {
    BackArrowIcon,
    SenderIcon,
    ReceiverIcon,
    InputButton,
    ClickIcon
  },
  data() {
    return {
      sender: false,
      receiver: false
    }
  },
  watch: {
    details() {
      this.currentStatus()
    }
  },
  computed: {
    ...mapState('arrange_details', ['details'])
  },
  methods: {
    back() {
      this.$emit('show-prohibited', true)
    },
    next() {
      if (this.receiver) {
        var value = { who: 'receiver', id: this.id }
        this.$store.dispatch('arrange/addWho', value)
        this.$emit('show-details', true)
      } else if (this.sender) {
        value = { who: 'sender', id: this.id }
        this.$store.dispatch('arrange/addWho', value)
        this.$emit('show-details', true)
      } else if (this.receiver == false && this.sender == false) {
        Swal.fire('Info', 'Select an option')
      }
    },
    selectSender() {
      this.neutral()
      this.sender = true
    },
    selectReceiver() {
      this.neutral()
      this.receiver = true
    },
    neutral() {
      this.sender = false
      this.receiver = false
    },
    currentStatus() {
      if (this.details && this.details.initiator) {
        if (this.details.initiator === 'receiver') {
          this.receiver = true
        } else {
          this.sender = true
        }
      }
    }
  },
  created() {
    this.$store.dispatch('arrange_details/getOrderArrangements', this.id)
  },
  mounted() {
    this.currentStatus()
  }
}
</script>
